/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Total_AmountInputs */

const en_case_payment_total_amount = /** @type {(inputs: Case_Payment_Total_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total amount`)
};

const pt_br2_case_payment_total_amount = /** @type {(inputs: Case_Payment_Total_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total`)
};

/**
* | output |
* | --- |
* | "Total amount" |
*
* @param {Case_Payment_Total_AmountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_total_amount = /** @type {((inputs?: Case_Payment_Total_AmountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Total_AmountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_total_amount(inputs)
	return pt_br2_case_payment_total_amount(inputs)
});